<script lang="ts">
export default {
  name: 'KkSelect',
}
</script>

<script lang="ts" generic="T" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  options: string[] | Record<string, T>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  modelValue: T
  name?: string
  disabled?: boolean
  placeholder?: string
}

export interface Emits {
  (key: 'update:modelValue', value: Props['modelValue']): void
}

const { t } = useI18n()
const props = withDefaults(defineProps<Props>(), {
  name: '',
})
const emits = defineEmits<Emits>()

const valueModel = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value),
})

const computedOptions = computed(() => {
  // 順番を入れ替えないこと。（typeof this.optionsはArrayでも'object'を返す）
  if (Array.isArray(props.options)) {
    const obj: Record<string, Props['modelValue']> = {}
    props.options.map(v => {
      obj[v] = v
    })
    return obj
  }
  if (typeof props.options === 'object') { return props.options }
  throw Error
})
</script>

<template>
  <div class="c-select">
    <select v-model="valueModel" :name="name" :disabled="disabled">
      <option value="" disabled :selected="modelValue === ''">{{ placeholder ?? t('labels.placeholder.select') }}</option>
      <option v-for="(val, key) in computedOptions" :key="key" :value="val">
        {{ key }}
      </option>
    </select>
  </div>
</template>
